import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useAppLoadingStore = defineStore('app-loading', () => {
  const pendingCount = ref(0)

  const isLoading = computed(() => pendingCount.value > 0)

  const start = () => {
    pendingCount.value += 1
  }

  const stop = () => {
    pendingCount.value = Math.max(0, pendingCount.value - 1)
  }

  const reset = () => {
    pendingCount.value = 0
  }

  return {
    isLoading,
    start,
    stop,
    reset,
  }
})
